// module factories are used so entry inlining is disabled
